import ManageEventInfo from "./ManageEventInfo";
export default ManageEventInfo;
